/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-26T12:44:37+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-27T13:02:06+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AIconInline from './../../icons/components/AIconInline';

/**
 * MErrorGroupInput - …
**/

class MErrorGroupInput extends Component {
  render() {
    const {
      children,
    } = this.props;
    return (
      <div className="m-error-group m-error-group-input">
        <AIconInline
          size="tiny"
          icon="warning-sign"
        />
        <ul className="m-error-group-input__errors">
          {children}
        </ul>
      </div>
    );
  }
}
MErrorGroupInput.propTypes = {
  children: PropTypes.any,
};
MErrorGroupInput.defaultProps = {};
export default MErrorGroupInput;

